module.exports = __webpack_public_path__ + "static/media/client-landing-4.bfc38a59.jpg";